import { useEffect, useState } from "react";
import $ from "jquery";
import AddIcon from "@mui/icons-material/Add";
import Button from "../Component/Common/Button";
import Table from "../Component/Common/Table";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../assets/icons/EditBtn.svg";
import { OPEN_DIALOGUE } from "../store/dialogue/dialogue.type";
import {
  getVideoCategory,
  videoCategoryActiveOrNot,
} from "../store/video/video.action";
import VideoCategoryAdd from "../Component/dialogue/VideoCategoryAdd";
import { covertURl } from "../util/AwsFunction";
import ToggleSwitch from "../Component/Common/ToggleSwitch";
import noImageFound from "../assets/images/noimage.png";
import PageContainer from "../Component/Common/Page";
import PageHeader from "../Component/Common/PageHeader";

const VideoCategory = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const { dialogueType } = useSelector((state) => state.dialogue);
  const [showURLs, setShowURLs] = useState([]);
  const { videoCategoryData } = useSelector((state) => state.video);

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", noImageFound);
    });
  });

  useEffect(() => {
    fetchData();
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data.map(async (item) => {
        const fileNameWithExtension = item?.image?.split("/").pop();
        const { imageURL } = await covertURl(
          "videoCategoryImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowURLs(urls);
  };

  const handleOpenNew = (type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const soundCategoryMapData = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => <span className="  text-nowrap">{index + 1}</span>,
    },
    {
      Header: "Image",
      body: "image",
      Cell: ({ row, index }) => (
        <img src={showURLs[index]} width="40px" height="40px" />
      ),
    },
    {
      Header: "CATEGORY NAME",
      body: "name",
      Cell: ({ row }) => <span className="text-capitalize">{row?.name}</span>,
    },
    {
      Header: "ACTIVE TOGGLE",
      body: "isActive",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isActive}
          onChange={() => handleIsActiveToggle(row)}
        />
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          <Button
            className="icon-btn"
            startIcon={<EditIcon />}
            onClick={() => handleEdit(row, "addCategory")}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getVideoCategory());
  }, [dispatch]);

  useEffect(() => {
    setData(videoCategoryData);
  }, [videoCategoryData]);

  const handleIsActiveToggle = (row) => {
    const id = row?._id;
    const data = row?.isActive === false ? true : false;
    dispatch(videoCategoryActiveOrNot(id, data));
  };
  return (
    <PageContainer className="userPage videoPage">
      <PageHeader
        heading={"Welcome Admin"}
        subHeading={"Video & Shorts Category"}
      />
      <div className="user-table">
        {dialogueType == "addCategory" && <VideoCategoryAdd />}
        <div className="user-table-top">
          <div className="row align-items-start">
            <div className="col-6"></div>
            <div
              className="col-6 new-fake-btn d-flex justify-content-end"
              style={{ marginTop: "5px" }}
            >
              <Button
                startIcon={<AddIcon />}
                className={"rounded"}
                onClick={() => handleOpenNew("addCategory")}
              >
                New
              </Button>
            </div>
          </div>
        </div>

        <Table
          data={data}
          mapData={soundCategoryMapData}
          noDataMessage="No Category Found!"
        />
      </div>
    </PageContainer>
  );
};

export default VideoCategory;
